import { useMemo } from 'react'
import { useLayerLookup } from './useLayerLookup'
import {
  useRiskProfileBaseParams,
  type UseRiskProfileBaseParamsOptions,
} from './useRiskProfileBaseParams'
import type { RiskProfileQueryParams } from '../types/riskProfile.types'

export type { RiskProfileQueryParams } from '../types/riskProfile.types'

type UseRiskProfileQueryParamsOptions = UseRiskProfileBaseParamsOptions & {
  selectedElementGroups: string[]
}

export const useRiskProfileQueryParams = ({
  selectedElementGroups,
  ...baseOptions
}: UseRiskProfileQueryParamsOptions): RiskProfileQueryParams | null => {
  const { selectedWorkspace } = baseOptions
  const { getTitle } = useLayerLookup()

  const elementTitles = useMemo(
    () =>
      selectedWorkspace !== null
        ? Object.fromEntries(selectedWorkspace.layers.assets.map((id) => [id, getTitle(id)]))
        : {},
    [selectedWorkspace, getTitle],
  )

  const base = useRiskProfileBaseParams(baseOptions)
  if (base === null || selectedWorkspace === null) return null

  return {
    ...base,
    assets: selectedWorkspace.layers.assets,
    selectedElementGroups,
    elementTitles,
  }
}
